const ErrorMessage = {
  network: {
    // 클라이언트가 인터넷에 연결되지 않았거나, API 서버가 정상적으로 동작하지 않을 경우 발생
    disconnected: '요청에 실패했습니다.\n인터넷 연결 상태를 확인해주세요.',
  },
  auth: {
    account: {
      empty: '아이디를 입력해주세요.',
      tooLong: '아이디가 너무 짧습니다. 5자 이상으로 입력해주세요.',
      tooShort: '아이디가 너무 깁니다. 20자 이하로 입력해주세요.',
      pattern: '이메일 형식에 맞지 않습니다.',
      already: '이미 사용중인 아이디입니다.',
      notFound: '아이디를 찾을 수 없습니다.',
    },
    password: {
      empty: '비밀번호를 입력해주세요.',
    },
    email: {
      empty: '이메일을 입력해주세요.',
      type: '이메일 형식에 맞게 입력해주세요.',
      already: '이미 사용중인 아이디입니다.',
      notFound: '이메일을 찾을 수 없습니다.',
    },
    name: {
      empty: '이름을 입력해주세요.',
      invalid: '한글, 영문만 입력할 수 있습니다.',
    },
    phone: {
      empty: '휴대폰 번호를 입력해주세요.',
      invalid: '휴대폰 번호가 올바른지 확인해주세요.',
    },
    company: {
      invalid: '회사 정보가 올바르지 않습니다.',
    },
  },
  objection: {},
};

export default ErrorMessage;
